import { render } from "./Aside.vue?vue&type=template&id=6cec27b3&scoped=true"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"

import "./Aside.vue?vue&type=style&index=0&id=6cec27b3&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cec27b3"]])

export default __exports__